<template>
  <div class="data-hub-search">
    <vs-divider position="left">When</vs-divider>
    <section class="timeline">
      <range-slider
        :id="'dataHubSlider'"
        :range-data="timelineData"
        :theme="'msp'"
        @change="updateActiveMomentId"
      ></range-slider>
    </section>
    <section id="data">
      <datahub-search-form
        v-if="btmDatahubActiveMoment.id === moments.past.id"
        name="past"
        :moment-id="moments.past.id"
      ></datahub-search-form>
      <datahub-search-form-present
        v-if="btmDatahubActiveMoment.id === moments.present.id"
        name="present"
        :moment-id="moments.present.id"
      ></datahub-search-form-present>
      <datahub-search-form
        v-if="btmDatahubActiveMoment.id === moments.shortTerm.id"
        name="shortTerm"
        :moment-id="moments.shortTerm.id"
      ></datahub-search-form>
      <datahub-search-form
        v-if="btmDatahubActiveMoment.id === moments.climateChange.id"
        name="climateChange"
        :moment-id="moments.climateChange.id"
      ></datahub-search-form>
    </section>
  </div>
</template>
<script>
import DataHubSearchFormPresent from "@/components/DataHubSearchFormPresent";
import DataHubSearchForm from "@/components/DataHubSearchForm.vue";
import RangeSlider from "@/components/ui/RangeSlider";
import { MOMENTS, TIMELINE_MOMENTS } from "@/constants.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    "range-slider": RangeSlider,
    "datahub-search-form": DataHubSearchForm,
    "datahub-search-form-present": DataHubSearchFormPresent
  },
  data() {
    return {
      timelineData: TIMELINE_MOMENTS,
      moments: MOMENTS
    };
  },
  computed: {
    ...mapState({
      btmDatahubActiveMoment: state => state.btmDatahubActiveMoment
    })
  },
  methods: {
    ...mapActions({
      setBTMDataHubActiveMoment: "setBTMDataHubActiveMoment"
    }),
    updateActiveMomentId(id) {
      const activeMoment = this.getMoment(id);
      this.setBTMDataHubActiveMoment(activeMoment);
      this.activeMomentId = id;
    },
    getMoment(id) {
      for (const prop of Object.keys(this.moments)) {
        if (this.moments[prop].id === id) return this.moments[prop];
      }
    }
  }
};
</script>
<style scoped>
.data-hub-search {
  flex: 1;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 0.8rem;
}
</style>
